module.exports = {
  // 全局版权
  Copyright: [
    "Copyright © 中国科技资料进出口有限责任公司",
    "京公安网备案号：",
    "地址(北京)：北京市海淀区西三环北路72号院B座2608",
    "地址(南京)：江苏省南京市鼓楼区广州路199号天诚大厦11层",
    "京ICP备案号："
  ],
  // 全局页脚
  Footer: [
    "关于我们",
    "公司简介",
    "组织结构",
    "合作伙伴",
    "公司文化",
    "党建和社会责任",
    "招聘信息",
    "公司业务",
    "原版图书进口",
    "电子资源进口",
    "报刊进口",
    "出口业务",
    "新闻动态",
    "企业动态",
    "行业资讯",
    "媒体资讯",
    "特色服务",
    "书展服务",
    "数据加工",
    "专业研究",
    "电话(北京):",
    "电话(南京):",
    "工作日：周一至周五",
    "周六日及部分节假日提供值班服务",
    "中科资料外文原版图书企业店",
    "工作时间：8：30-17：30"
  ],
  // 首页新闻列表
  HomeNewsList: {
    news: "企业动态",
    bookFair: "行业资讯",
    video: "宣传视频",
    seeMore: "查看更多",
  },
  // 首页业务列表
  BusinessList: {
    LearnMore: "了解详情",
    Importoforiginalbooks: "原版图书进口",
    Importofelectronicresources: "电子资源进口",
    Newspaperimport: "报刊进口",
    Businessexport: "出口业务",
    BookFairServices: "书展服务",
    ImportoforiginalbooksMS:
      "经过多年的深度耕耘，中国科技资料进出口有限责任公司运营形成了集书目采集、学科分析、海外订购、集货发运和数据制作于一体的原版图书进口业务链条，具有全学科品种提供服务的能力，累计为国内超过500多所的高校、科研院所及公共图书馆订购了近百万册的原版图书，在业界享有优良的口碑。",
    ImportofelectronicresourcesMS:
      "电子资源/数据库代理进口是我公司重要业务，增长速度很快，近年来累计为国内几百家高等院校、科研院所及公共图书馆等客户提供了近千种数据库产品，为客户数字资源馆藏建设起到了支持作用。中科公司携手国际知名数字资源供应商，如Springer,，Clarivate Analytics,，Wiley， Elsevier, Taylor & Francis，牛津大学出版社，剑桥大学出版社，Igroup等，为客户提供受知识产权保护、合乎中国法律规定的正版电子/数据库资源",
    NewspaperimportMS:
      "中国科技资料进出口有限责任公司，是国内主要的期刊进口服务商之一，与国际知名出版社和国外的学协会建立了良好的合作关系，可为国内客户进口100多个国家/地区出版机构发行的各类原版期刊10余万种。主要面向国内高校、科研单位、政府机关、企业，以及地方公共图书馆征订，并提供可靠周到的服务。",
    BusinessexportMS:
      "中国科技资料进出口有限责任公司出口业务主要包括中文图书、报刊、音像制品、电子出版物等实物文化产品出口及版权输出、国际会展。为了提升中国文化在世界上的影响力，中科公司积极响应国家“文化走出去”的号召，结合自身优势，着力开展了国内出版物的版权输出工作，近年来成绩斐然。受上级部门委托，根据自身优势，还组织中国出版机构及其出版物参加了2018、2019 年印尼国际书展和2019 年泰国曼谷国际书展（实体展），以及2020、2021年印尼国际书展（线上展），将传统的版权贸易延伸到海外出版领域。",
    BookFairServicesMS:
      "我公司本着“为人找书、为书找人”的服务理念，针对学术性原版图书的进口销售，创新性地设计开发了一种销售、服务模式，全称为海外学术原版新书巡回展（简称“MBE”）。“MBE”为图书馆的外文图书采购带来更多的便捷，让图书馆得到最大的优惠，同时也最大程度地缩短了图书馆的采购周期，日渐成为图书馆外文原版图书采访工作的重",
  },
  // 首页关于我们
  AboutUs: {
    title: "公司简介",
    content: [
      "中国科技资料进出口有限责任公司是1987年由原国家外经贸部批准成立的有限责任公司（法人独资）。公司主要经营图书、报纸、期刊、电子文献及电子书的进口业务，版权进出口业务，相关批发和零售业务，已取得《出版物经营许可证》、《出版物进口经营许可证》。",
      "中科公司在经营中追求为客户提供“专业化、人性化和个性化”的专业服务，先后在北京、南京、上海、广州、武汉、成都、西安设立办公点，保证了对客户服务的及时响应。中科公司以深厚的专业积累、细致周到的服务在行业中创下了优良的口碑，客户覆盖面和业务量成倍增长。除此之外公司与国内的公共图书馆、科研院所等单位的图书文献机构也有着长期良好的业务关系。",
      "我公司通过多年的经营已同全球近千家知名出版集团或出版社建立了合作关系或有业务往来，保持着良好的业务关系，成为其中国大陆地区主要代理商之一。我公司着力扩充小语种图书、绝版图书或者出版时间久远图书的采购渠道，特别是开辟东南亚图书的采购渠道，改善了过去对这一地区采购图书的困难状况，提高了客户满意度。外文原版图书的总体订到率在行业中名列前茅。",
    ],
  },
  // 首页标签开关
  ToggleList: {
    title: [
      "携手共赢，与全球合作伙伴共建图书馆藏新时代",
      "中科公司愿与境外出版社、国内高等学校图书馆、研究院文献中心、公共图书馆等机构精诚合作、携手共赢，共同探讨新时代下的图书馆藏建设。",
    ],
    bar: ["公司简介", "合作伙伴", "党建和社会责任"],
    aus: ["成立于", "注册资本", "服务对象", "万"],
  },
  // 公司简介正文 introduction
  introduction: {
    title: "中国科技资料进出口有限责任公司",
    tag: ["成立于1987年", "100余人的专业团队", "服务对象1000余家"],
    container: [
      "中国科技资料进出口有限责任公司是1987年由原国家外经贸部批准成立的有限责任公司（法人独资）。公司主要经营图书、报纸、期刊、电子文献及电子书的进口业务，版权进出口业务，相关批发和零售业务，已取得《出版物经营许可证》、《出版物进口经营许可证》。",
      "中科公司在经营中追求为客户提供“专业化、人性化和个性化”的专业服务，先后在北京、南京、上海、广州、武汉、成都、西安设立办公点，保证了对客户服务的及时响应。中科公司以深厚的专业积累、细致周到的服务在行业中创下了优良的口碑，客户覆盖面和业务量成倍增长。目前与中科公司有业务往来的国内高校多达400余家，与全国大部分重点高校均有长期的业务往来。除此之外公司与国内的公共图书馆、科研院所等单位的图书文献机构也有着长期良好的业务关系。",
      "我公司通过多年的经营已同全球近千家知名出版集团或出版社建立了合作关系或有业务往来，保持着良好的业务关系，成为其中国大陆地区最大的代理商之一。我公司着力扩充小语种图书、绝版图书或者出版时间久远图书的采购渠道，特别是开辟东南亚图书的采购渠道，改善了过去对这一地区采购图书的困难状况，提高了客户满意度。外文原版图书的总体订到率在行业中名列前茅。",
      "从2005年起，经原国家新闻出版总署批准，我公司开创性地在国内重点院校及科研单位举办“外文原版图书巡回书展”，借助这一平台，让读者能够直观见到国外最新的原版图书，缩短了到货周期，为客户采购外文原版图书带来更多便捷。这一首创性的服务模式是我公司为提升业内服务层次所做的有益尝试，已成为我公司的业务特色和品牌标志。中科公司建立了完备的国际物流系统，在美国、英国、德国、新加坡、香港、印度等地拥有指定的空运和海运货运代理商，物流网络覆盖了全球主要国家和地区。国内运输全部实现“到桌”式服务。",
      "中科拥有一支精通业务、拼搏向上、不断进取、敬业团结的员工队伍。现有员工近百人，下设客服部、销售部、市场研究部、进口部、财务部、人力行政部、总经理办公室、审读办公室、出口部、期刊部等部门。公司人员以80后为主力，新老衔接合理、业务骨干年富力强、后备梯队承接有序。公司人员都有较高的教育背景，硕士研究生学历和本科生学历占到公司人员70%以上。",
      "在多年来的经营中中科公司逐渐积淀了深厚的行业资源，建立了顺畅的经营体系，凭借多年经营的良好业绩和在行业中的影响力，经国家新闻出版广电总局批准，中科公司在对国内高等院校、科研院所开展相关业务时可享受免税的政策，这一政策大大促进了中科公司同国内高等院校、科研院所及各级图书馆的合作，也充分印证了中科公司在行业内具有的实力。中科公司以“创新、诚信、服务、求实”为经营理念，以扩大国际科技信息交流、引进高新技术、发展对外科技贸易为宗旨，立志为我国科技进步和信息化建设提供专业的服务。",
    ],
  },
  // 面包组件
  currentPosition: "当前位置:",
  // 企业文化标语
  slogan: "创新 诚信 服务 求实",
  //
  loadMore: "加载更多",
  noMore: "没有更多了",
  seeMore: "查看更多+",
  home: "首页",
};
